// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckboxHeader_container__1Jk--","checkbox":"CheckboxHeader_checkbox__3XHJV","checkboxMark":"CheckboxHeader_checkboxMark__2hnCc"};